import * as yup from "yup";

const nameRegex = /^[A-Za-z\u0621-\u064A]+$/;
const salesIdRegex = /^[A-Za-z0-9]*$/;

const validateEgPhone = (mobile) => {
  if (!mobile) return false;

  let phoneLen = 11;
  let charLen = 2;
  if (!mobile.startsWith("0")) {
    phoneLen = 10;
    charLen = 1;
  }

  if (mobile.length > phoneLen) return false;
  if (
    mobile.length >= charLen &&
    !mobile.startsWith(`${charLen === 2 ? "0" : ""}1`)
  ) {
    return false;
  }
  if (
    mobile.length >= charLen + 1 &&
    !mobile.startsWith(`${charLen === 2 ? "0" : ""}10`) &&
    !mobile.startsWith(`${charLen === 2 ? "0" : ""}11`) &&
    !mobile.startsWith(`${charLen === 2 ? "0" : ""}12`) &&
    !mobile.startsWith(`${charLen === 2 ? "0" : ""}15`)
  ) {
    return false;
  }
  if (mobile.length < 10) return false;
  if (mobile.length === 10 && mobile.startsWith("0")) return false;

  return true;
};

const validateAePhone = (mobile) => {
  if (!mobile) return false;
  if (mobile.length !== 9) return false;

  const validPrefixes = ["50", "52", "54", "55", "56", "58"];
  return validPrefixes.includes(mobile.substring(0, 2));
};

export const createSignUpSchema = (t) =>
  yup.object({
    firstName: yup
      .string()
      .trim()
      .required(t("auth.requiredFirstName"))
      .min(3, t("auth.invalidName"))
      .matches(nameRegex, t("auth.invalidName")),
    middleName: yup
      .string()
      .trim()
      .required(t("auth.requiredSecondName"))
      .min(3, t("auth.invalidName"))
      .matches(nameRegex, t("auth.invalidName")),
    lastName: yup
      .string()
      .trim()
      .required(t("auth.requiredThirdName"))
      .min(3, t("auth.invalidName"))
      .matches(nameRegex, t("auth.invalidName")),
    email: yup
      .string()
      .trim()
      .required(t("auth.requiredEmail"))
      .email(t("auth.invalidEmail")),
    selectedCountry: yup.string().oneOf(["eg", "ae"]).required(),
    mobile: yup
      .string()
      .required(t("auth.requiredMobile"))
      .when("selectedCountry", {
        is: "eg",
        then: (schema) =>
          schema.test("eg-phone", t("auth.invalidMobile"), validateEgPhone),
        otherwise: (schema) =>
          schema.test("ae-phone", t("auth.invalidMobile"), validateAePhone),
      }),
    image: yup.mixed().when("selectedCountry", {
      is: "eg",
      then: (schema) =>
        schema
          .required(t("auth.requiredIdImage"))
          .test("file-type", t("auth.invalidIdImage"), (value) => {
            if (!value) return false;
            return value.type?.startsWith("image/");
          }),
      otherwise: (schema) => schema.nullable().notRequired(),
    }),
    salesId: yup
      .string()
      .transform((value) => value ?? "")
      .test("sales-id", t("auth.invalidSalesId"), (value) => {
        if (!value) return true;
        if (!salesIdRegex.test(value)) return false;
        return value.length === 6;
      }),
    isTermsAccepted: yup
      .boolean()
      .oneOf([true], t("auth.requiredTerms"))
      .required(t("auth.requiredTerms")),
  });

export const formatSignupMobile = (mobile, selectedCountry) => {
  if (selectedCountry === "eg") {
    return `2${mobile.length === 10 && !mobile.startsWith("0") ? "0" : ""}${mobile}`;
  }
  return `971${mobile}`;
};
